module.exports = __webpack_public_path__ + "img/宣传_118.b9e85e49.jpg";